import React from 'react';
import './FormInput.css'

const FormInput = (props) => {
    return ( 
        <div className='FormInput'>
            <label>{props.InputName}</label>
            <input type={props.InputType} />
        </div>
     );
}
 
export default FormInput;